import React from 'react';

const ThemeFiveTitles = props => {
  return (
    <div className={`themes-theme-five-titles new-container  ${props.className}`}>
      {props.smallHeading && <div className="font10 less-bold-text mb5">{props.smallHeading}</div>}

      {props.boldHeading && (
        <div className="font13 bold-text mb5 black-text-color">{props.boldHeading}</div>
      )}
    </div>
  );
};

export default ThemeFiveTitles;



// WEBPACK FOOTER //
// ./src/features/themes/theme5/components/ThemeFiveTitles.js